import {RichTextField, isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import {AnimatedTextBlockSliceDefaultPrimaryStaticTextBlockItem} from 'prismicio-types'
import {useState} from 'react'
import {useEffectOnce} from 'react-use'
import {ParagraphComponent} from './textComponents/ParagraphComponent'
import {MobileSlots} from './types'
import styles from './staticSectionStyles.module.css'
import cn from 'classnames'
import ScrollableSection from './ScrollableSection'

export const ContentSection = ({
  title,
  textBlock,
  mobileSlots,
  scrollableBlock,
}: {
  title: RichTextField
  textBlock: AnimatedTextBlockSliceDefaultPrimaryStaticTextBlockItem[]
  mobileSlots?: MobileSlots
  scrollableBlock: RichTextField
}) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffectOnce(() => {
    setIsMounted(true)
  })

  return (
    <div className="flex min-h-[100vh] flex-col gap-6">
      {isFilled.richText(title) && (
        <div
          className={cn({
            'opacity-0 blur-[2px]': !isMounted,
            fadeInUp: isMounted,
          })}
        >
          <PrismicRichText
            field={title}
            components={{
              heading2: ({children}) => {
                return (
                  <h1 className="lg:text-tg-h2 pb-6 text-32 leading-[normal] tracking-[-.32px] text-moss-white">
                    {children}
                  </h1>
                )
              },
              strong: ({children}) => <span className="font-normal text-green-neon">{children}</span>,
            }}
          />
        </div>
      )}

      {textBlock.length > 0
        ? textBlock.map(({paragraph}, index) => {
            if (!paragraph || !isFilled.richText(paragraph)) {
              return null
            }

            return (
              <div
                key={`static-text-block-${index}`}
                className={cn(styles.stagger, {
                  'opacity-0 blur-[2px]': !isMounted,
                  fadeInUp: isMounted,
                })}
                style={{
                  ['--i' as any]: index,
                }}
              >
                <PrismicRichText
                  field={paragraph}
                  components={{
                    paragraph: ({children, node}) => {
                      return (
                        <ParagraphComponent node={node} mobileSlots={mobileSlots}>
                          {children}
                        </ParagraphComponent>
                      )
                    },
                    strong: ({children}) => <span className="font-normal text-green-neon">{children}</span>,
                  }}
                />
              </div>
            )
          })
        : null}
      {/* Scroll-based animated text block */}
      {isFilled.richText(scrollableBlock) && (
        <div
          className={cn(styles.stagger, {
            'opacity-0 blur-[2px]': !isMounted,
            fadeInUp: isMounted,
          })}
          style={{
            ['--i' as any]: textBlock.length,
          }}
        >
          <ScrollableSection field={scrollableBlock} mobileSlots={mobileSlots} />
        </div>
      )}
    </div>
  )
}
